import firebase from 'firebase/compat/app';
import 'firebase/compat/functions';

import initializeApp from './firebase-init';
initializeApp();

const functions = firebase.functions;
export default functions;
